import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=8811d8be&scoped=true"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"
import style0 from "./about_us.vue?vue&type=style&index=0&id=8811d8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8811d8be",
  null
  
)

export default component.exports